<dx-popup class="popup" [width]="600" [height]="450" [showTitle]="true"
    [title]="'WACHTWOORD_WIJZIGEN.TITEL' | translate" [dragEnabled]="false" [hideOnOutsideClick]="false"
    [(visible)]="popupVisible" [showCloseButton]="false">
    <div *dxTemplate="let data of 'content'">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessages">
            {{ errorMessages }}
        </div>
        <form (submit)="onFormSubmit($event)">
            <dx-form id="form" [formData]="user" [readOnly]="false" [showColonAfterLabel]="true"
                [showValidationSummary]="true">
                <dxi-item dataField="OldPassword" [editorOptions]="{ mode: 'password' }">
                    <dxo-label [text]="'WACHTWOORD_WIJZIGEN.HUIDIG_WACHTWOORD' | translate"></dxo-label>
                    <dxi-validation-rule type="required"
                        [message]="'WACHTWOORD_WIJZIGEN.HUIDIG_WACHTWOORD_VERPLICHT' | translate">
                    </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="NewPassword" [editorOptions]="{ mode: 'password' }">
                    <dxo-label [text]="'WACHTWOORD_WIJZIGEN.NIEUW_WACHTWOORD'| translate"></dxo-label>
                    <dxi-validation-rule type="required"
                        [message]="'WACHTWOORD_WIJZIGEN.NIEUW_WACHTWOORD_VERPLICHT'| translate">
                    </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="ConfirmPassword" editorType="dxTextBox" [editorOptions]="{ mode: 'password' }">
                    <dxo-label [text]="'WACHTWOORD_WIJZIGEN.HERHAAL_NIEUW_WACHTWOORD'| translate">
                    </dxo-label>
                    <dxi-validation-rule type="required"
                        [message]="'WACHTWOORD_WIJZIGEN.HERHAAL_NIEUW_WACHTWOORD_VERPLICHT'| translate">
                    </dxi-validation-rule>
                    <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison"
                        [message]="'WACHTWOORD_WIJZIGEN.NIEUW_WACHTWOORD_KOMTNIETOVEREEN' | translate">
                    </dxi-validation-rule>
                </dxi-item>
            </dx-form>
            <br />
            <div>
                <dx-button [text]="'WACHTWOORD_WIJZIGEN.ANNULEREN' | translate" type=" warning"
                    [useSubmitBehavior]="false" (click)="hide()"></dx-button>&nbsp;&nbsp;
                <dx-button [text]="'WACHTWOORD_WIJZIGEN.TITEL' | translate" type="success" [useSubmitBehavior]="false"
                    (click)="onFormSubmit($event)"></dx-button>
            </div>
        </form>
    </div>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>